<template>
  <div>
    <v-list-item :disabled="ticketsLeft <= 0" :style="'background-color:' + (active ? 'rgba(173, 216, 230, .5)' : '')" @click="active = !active">
      <v-list-item-content>
        <v-list-item-title>{{ performance.dateStr }}</v-list-item-title>
        <v-list-item-subtitle>Tickets Left: {{ ticketsLeft > 0 ? ticketsLeft : 'Sold Out' }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-card v-if="active" class="ma-2 ml-8" elevation="2">
      <v-card-text class="mt-0">
        <p>Please choose your ticket quantity for each option below.</p>
        <v-row class="pt-0">
          <v-col v-for="{ label, price, limit } of priceOptions" :key="label + '-' + price" :cols="12" :md="6" :xl="4">
            <v-select :items="ticketOptions(limit || 20)" :label="`${label} - $${price}`" :disabled="/Discount/.test(label) && limit === 0" outlined hide-details @change="(v) => updateTickets(label, v)" />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { ref, computed } from '@vue/composition-api'

export default {
  props: {
    showId: String,
    name: String,
    performance: Object,
    isAdmin: {
      type: Boolean,
      default: false
    }
  },
  setup (props, { root, emit }) {
    const user = computed(() => 'spoof' in root.$store.state.user ? root.$store.state.user.spoof : root.$store.state.user)
    const active = ref(false)
    const first = ref('')
    const last = ref('')
    const email = ref('')

    const ticketsLeft = computed(() => (props.performance.tickets || 0) - (props.performance.reserved || 0))
    const priceOptions = computed(() =>
      props.performance.prices.filter(({ label }) => {
        if (label === 'Covenant Student' && !(user.value && user.value.roles && user.value.roles.includes('Student'))) return false
        if (label === 'Covenant Faculty/Staff' && !(user.value && user.value.roles && user.value.roles.includes('Employee'))) return false
        return true
      })
    )
    const tickets = ref([])
    const total = computed(() => {
      let total = 0
      for (const { label, count } of tickets.value) {
        const rec = priceOptions.value.find(({ label: l }) => label === l)
        if (rec) {
          total += rec.price * count
        }
      }
      return total
    })
    function updateTickets (label, count) {
      // console.log({ label, count })
      // const index = tickets.value.findIndex(({ label: l }) => label === l)
      // if (index >= 0) {
      //   if (count === 0) tickets.value.splice(index, 1)
      //   else tickets.value.splice(index, 1, { label, count })
      // } else if (count > 0) {
      //   tickets.value.push({ label, count })
      // }
      emit('update', { label, count })
    }

    function ticketOptions (limit) {
      const arr = []
      const max = (limit < ticketsLeft.value ? limit : ticketsLeft.value)
      for (let i = 0; i <= max; i++) {
        arr.push({ text: i + ' Ticket' + (i === 1 ? '' : 's'), value: i })
      }
      return arr
    }

    const valid = computed(() => tickets.value.length > 0 && (user.value || (first.value && last.value && email.value)))

    return {
      user,
      active,
      first,
      last,
      email,
      ticketsLeft,
      priceOptions,
      tickets,
      total,
      updateTickets,
      ticketOptions,
      valid
    }
  }
}
</script>
